<h2 mat-dialog-title style="color: red">
  {{ 'shoppingCart.payment.error.title' | translate }}
</h2>
<mat-dialog-content class="mat-typography">
  @for (code of codes; track code) {
    <p > {{ 'shoppingCart.payment.error.' + code |translate}} </p>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Ok</button>
</mat-dialog-actions>